import React from "react";
import { Card } from "antd";
import { LineChart } from "@mui/x-charts/LineChart";
import { axisClasses } from "@mui/x-charts";
import { useTranslation } from "react-i18next";

const ExpenseCard = ({ expenseData }) => {
    const { t, i18n } = useTranslation();

    // Extract expense_datewise and total_expense from API response

    console.log("CNCACDDCA---->", expenseData);

    const Data =
        expenseData?.expense_datewise?.map((item) => ({
            x: item.date,
            y: item.amount,
        })) || [];

    const totalExpense = expenseData?.total_expenses || 0;

    return (
        <Card className="col-span-12 md:col-span-6 shadow rounded-2xl">
            <h2 className="font-semibold text-lg mb-4">{t("Expense Overview")}</h2>

            <LineChart
                dataset={Data}
                xAxis={[
                    {
                        dataKey: "x",
                        scaleType: "band",
                        label: (t("Date")),
                        labelStyle: {
                            fontWeight: 600,
                        },
                    },
                ]}
                yAxis={[
                    {
                        label: (t("Expense")),
                        labelStyle: {
                            fontWeight: 600,
                        },
                    },
                ]}
                series={[
                    {
                        dataKey: "y",
                        area: true,
                        curve: "monotoneX",
                        color: "#3B82F6", // blue
                    },
                    // {
                    //     dataKey: "y",
                    //     area: false,
                    //     curve: "linear",
                    //     color: "#F59E0B",
                    //     showMark: false,
                    //     highlightScope: { highlighted: "none", faded: "global" },
                    //     strokeDasharray: "5 5",
                    // },
                ]}
                sx={{
                    [`& .${axisClasses.directionY} .${axisClasses.label}`]: {
                        transform: "translateX(-30px)",
                    },
                }}
                height={250}
                margin={{ top: 20, right: 20, left: 80, bottom: 40 }}
            />

            {/* Footer with total expenses */}
            <div className="mt-4 p-3 bg-[#FEF2F2] rounded-lg text-sm flex justify-between items-center">
                <span className="font-semibold text-gray-700">{t("Total Expenses")}</span>
                <span className="text-lg font-bold text-gray-900">
                    EGP {totalExpense.toLocaleString()}
                </span>
            </div>
        </Card>
    );
};

export default ExpenseCard;
